var _defs, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShield(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Shield_svg__b{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "Shield_svg__b",
    d: "M20 11.212a10.38 10.38 0 01-7.48 9.716 1.914 1.914 0 01-1.04 0A10.38 10.38 0 014 11.212v-4a2 2 0 011.243-1.849l4.864-1.99a5 5 0 013.787 0l4.864 1.99A2 2 0 0120 7.214z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "Shield_svg__b",
    d: "M13.079 8.501a1.525 1.525 0 11-2.157 0 1.525 1.525 0 012.157 0M12.001 13.268c1.744 0 3.446.753 3.446 1.911v.381a.383.383 0 01-.383.383H8.938a.383.383 0 01-.383-.383v-.383c0-1.159 1.7-1.911 3.446-1.911"
  })));
}
export default SvgShield;


//////////////////
// WEBPACK FOOTER
// ./src/components/Quoters/Aflac/icons/Shield.svg
// module id = 7870
// module chunks = 13